
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { areProConditionsUsedInRules } from "@/lib/subscriptions/free-mode";
import { Condition, RuleGroup } from "@/types/conditions";
import ProOnlyAlertBox from "@/components/Subscription/ProOnlyAlertBox.vue";
@Component({
  components: { ProOnlyAlertBox }
})
export default class FreeModeAlertForConditionsUsed extends Vue {
  @Prop()
  value!: RuleGroup[];

  @Prop()
  availableConditions!: Condition[];

  get areProConditionsUsedInRules() {
    return areProConditionsUsedInRules(
      this.value,
      this.availableConditions.filter(condition => condition.proOnly)
    );
  }
}
